export const companyMetricsSelector = ({ metrics: { companyMetrics: value = [] } }) => value;
export const userMetricsNotesSelector = ({ metrics: { userMetricsNotes: value = [] } }) => value;
